import { PNG_CONTENT_TYPE } from "@/utils/Constant";
import { addBase64UrlPrefix } from "@/utils/helpers/base64-helper";
import { CheckCircleFilled } from "@ant-design/icons";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/core/buttons/BasicButton";

interface LoadImageFieldProps {
  imgSrc?: string;
  contentType?: string;
  onClick: () => void;
  onDelete: () => void;
  isSelected?: boolean;
  loadIcon: ReactNode;
  loadText?: string;
  isSignatureImage?: boolean;
}

const LoadImageField: FunctionComponent<LoadImageFieldProps> = ({
  imgSrc,
  contentType = PNG_CONTENT_TYPE,
  onClick,
  onDelete,
  isSelected = false,
  loadIcon,
  loadText,
  isSignatureImage,
}) => {
  const { t } = useTranslation();

  const base64Data = imgSrc
    ? imgSrc?.includes("base64")
      ? imgSrc
      : addBase64UrlPrefix(imgSrc, contentType)
    : undefined;

  return (
    <div className={`load-image-field ${isSelected ? "valid" : ""}`}>
      <div
        className={`edit-or-image-container ${isSignatureImage ? "signature-upload" : ""}`}
        onClick={onClick}
      >
        {base64Data ? (
          <img src={base64Data} className="image" />
        ) : (
          <div className="load-image">
            {loadIcon}
            {loadText && <span className="load-image-text">{loadText}</span>}
          </div>
        )}
      </div>
      {base64Data && (
        <div className="d-flex align-items-center">
          <>
            <BasicButton
              text={
                <DeleteIcon
                  title={t("account.myInformations.deleteImage")}
                  className="cursor-pointer icon-30"
                />
              }
              variant="white ml-10"
              onClick={onDelete}
            />
          </>
        </div>
      )}
      {isSelected && <CheckCircleFilled className="check-sign" />}
    </div>
  );
};

export default LoadImageField;
